export default __webpack_public_path__ + "static/media/xp-bed.00547d23.svg";